// Import model
import { CreateRoomSelectionRequest } from '../models/CreateRoomSelectionRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreateRoomSelectionRequest - handles JSON serialization and deserialization with type validation
 */
export class CreateRoomSelectionRequestSerializer {
  /**
   * Deserializes a JSON string into a CreateRoomSelectionRequest instance
   */
  static deserialize(json: string): CreateRoomSelectionRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreateRoomSelectionRequest instance
   */
  static fromObject(obj: any): CreateRoomSelectionRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreateRoomSelectionRequest');
    }


    const instance: CreateRoomSelectionRequest = {
      installationTypeId: obj['installationTypeId'] as string | undefined,
      productType: obj['productType'] as string,
      patternTypeId: obj['patternTypeId'] as string | undefined,
      trimWorkId: obj['trimWorkId'] as string | undefined,
      underlaymentId: obj['underlaymentId'] as string | undefined,
      catalogFeedId: obj['catalogFeedId'] as string,
      itemId: obj['itemId'] as string,
      styleNumber: obj['styleNumber'] as string,
      bin: obj['bin'] as string,
      projectExternalId: obj['projectExternalId'] as string,
      roomIds: obj['roomIds'] ? (obj['roomIds'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      name: obj['name'] as string,
      description: obj['description'] as string | undefined,
      wasteFactor: obj['wasteFactor'] as number | undefined,
      binId: obj['binId'] as string,
      sessionKey: obj['sessionKey'] as string,
      hash: obj['hash'] as string,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreateRoomSelectionRequest instances
   */
  static deserializeArray(json: string): CreateRoomSelectionRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreateRoomSelectionRequest instance to a JSON string
   */
  static serialize(instance: CreateRoomSelectionRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreateRoomSelectionRequest instance to a plain object
   */
  static toObject(instance: CreateRoomSelectionRequest): any {
    return {
      'installationTypeId': instance.installationTypeId,
      'productType': instance.productType,
      'patternTypeId': instance.patternTypeId,
      'trimWorkId': instance.trimWorkId,
      'underlaymentId': instance.underlaymentId,
      'catalogFeedId': instance.catalogFeedId,
      'itemId': instance.itemId,
      'styleNumber': instance.styleNumber,
      'bin': instance.bin,
      'projectExternalId': instance.projectExternalId,
      'roomIds': instance.roomIds?.map((item: any) =>
        item
      ),
      'name': instance.name,
      'description': instance.description,
      'wasteFactor': instance.wasteFactor,
      'binId': instance.binId,
      'sessionKey': instance.sessionKey,
      'hash': instance.hash,
    };
  }

  /**
   * Serializes an array of CreateRoomSelectionRequest instances to a JSON string
   */
  static serializeArray(instances: CreateRoomSelectionRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
